import script from "./AppHeaderSettingsExcludesItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderSettingsExcludesItem.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderSettingsExcludesItem.vue?vue&type=style&index=0&id=2e3eb84d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e3eb84d"]])

export default __exports__